export const mapLaguageToLocalizedDateFormatter = (language) => {
  let mappedLanguage = "en"
  switch (language) {
    case 'en_us':
      mappedLanguage = 'en-EN';
      break;
    case 'fr_ca':
      mappedLanguage = 'fr-CA'
      break
    case 'fr_fr':
      mappedLanguage = 'fr-FR'
      break
    case 'pt_br':
      mappedLanguage = 'pt-PT'
      break
    case 'it_it':
      mappedLanguage = 'it-IT'
      break
    case 'es_es':
      mappedLanguage = 'es-ES'
      break
    case 'de_de':
      mappedLanguage = 'de-DE'
      break
  }

  return mappedLanguage;
}

export const supportedLanguages = ["fr_ca","pt_br","fr_fr","it_it","es_es","de_de","en_us"]

export const getLanguageCodeAndCountryByLangCode = (languageCode) => {
  let LangCode_langCountry ='';
  switch (languageCode) {
    case "fr_fr":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry = "French-France (fr-FR)";
      break;
    case "fr_ca":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry = "French-Canada (fr-CA)";
      break;
    case "de_de":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry ="German (de)";
      break;
    case "es_es":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry = "Spanish (es)";
      break;
    case "it_it":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry ="Italian (it)";
      break;
    case "pt_br":
      console.log("languageCode: ", languageCode);
      LangCode_langCountry = "Portuguese (pt)";
      break;
  }
  return LangCode_langCountry;
}
